<template>
	<basic-container>
		<avue-crud
			ref="crud"
			v-model="formData"
			:page.sync="page"
			:upload-after="uploadAfter"
			v-bind="bindVal"
			v-on="onEvent"
			@on-load="getList"
			@row-del="onDel"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange">
			<template slot="materialLabelForm" slot-scope="{row}">
				<el-checkbox-group v-model="formData.materialLabel">
					<el-checkbox v-for="item in crud.DIC.materialLabelE" :key="item.id" :label="item.id">
						{{ item.name }}
					</el-checkbox>
				</el-checkbox-group>
			</template>
		</avue-crud>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
import {mapGetters} from 'vuex'

const option = {
	//模块名字
	name: 'newGuidance',
	optionPath: 'newGuidance/newGuidance',
	optionNameList: ['newGuidanceOption'],
	apiPath: 'newGuidance/newGuidance',
	//接口名字
	apiNameList: ['queryList'],
	apiNameDelList: ['delObj'],
	apiNameAddList: ['addObj'],
	apiNameUpdateList: ['putObj'],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		data() {
			return {}
		},
		watch: {},
		created() {},
		computed: {
			...mapGetters(['permissions']),
			crud() {
				return this.$refs.crud
			},
		},
		methods: {
			//上传文件之前
			uploadAfter(res, done, loading, column) {
				if (res.code == 0) {
					setTimeout(() => {
						this.formData.file = res.data
						this.$message.success('文件上传成功!')
					}, 200)
				}
				done()
			},
			//处理新增数据
			rowSaveReqData() {
				let formdata = {
					...this.formData,
					useAuth: Array.isArray(this.formData.useAuth) ? this.formData.useAuth.join(',') : this.formData.useAuth,
				}
				return formdata
			},
			rowUpdateReqData() {
				let formdata = {...this.formData}

				return formdata
			},
			//可以重写getList() {},
			//列表前操作方法
			listBefore() {},
			//列表后操作方法
			listAfter() {},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//额外添加请求参数
			addRequestData() {
				// return { orders: { asc: false, column: 'sort' } }
			},
			onDel(row, index) {
				row.name = `${row.name}`
				this.rowDel(row, index)
			},
		},
	},
	option,
)
</script>

<style lang="scss" scoped></style>
